var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddChart = function SvgAddChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 21 20",
    width: 21,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.5451 3.67435-.9083-2.00833-.9083 2.00833-2.0084.90833 2.0084.90834.9083 2.00833.9083-2.00833 2.0084-.90834zm1.6917 3.30833-.5167-1.15-.5166 1.15-1.15.51667 1.15.51667.5166 1.15.5167-1.15 1.15-.51667zm-13.01667 9.68332h11.66667v-5h1.6667v5c0 .9167-.75 1.6667-1.6667 1.6667h-11.66667c-.91666 0-1.66666-.75-1.66666-1.6667v-11.66665c0-.91667.75-1.66667 1.66666-1.66667h5v1.66667h-5zm8.33337-1.6667v-4.99995h1.6666v4.99995zm-1.6667 0h-1.66667v-8.33329h1.66667zm-3.33333-6.66662v6.66662h-1.66667v-6.66662z",
    fill: "#777776",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_chart.b49ebd10.svg";
export { ForwardRef as ReactComponent };